/*
  Glimmery footer: "Cookie preferences" button. Shown only when Shopify's cookie banner API
  (window.privacyBanner.showPreferences, Customer Privacy API) is available; the banner script loads
  asynchronously, so availability is checked a few times after load. Registered once.
  Also keeps the country/language forms (footer + menu drawer, .g-localization) returning to the page
  the shopper is on: the Front/Back print swap changes the URL without re-rendering header or footer.
*/
(() => {
  if (window.glimmeryFooterInit) return;
  window.glimmeryFooterInit = true;

  const hasApi = () => !!window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';

  const reveal = () => {
    if (!hasApi()) return false;
    document.querySelectorAll('[data-g-cookie-preferences][hidden]').forEach((item) => {
      item.hidden = false;
    });
    return true;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('g-localization')) return;
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search;
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-g-cookie-preferences] button');
    if (!button || !hasApi()) return;
    event.preventDefault();
    try {
      Promise.resolve(window.privacyBanner.showPreferences()).catch(() => {});
    } catch (error) {
      // The banner is managed by Shopify; nothing to recover here.
    }
  });

  let attempts = 0;
  const poll = () => {
    if (reveal() || attempts >= 20) return;
    attempts += 1;
    window.setTimeout(poll, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poll, { once: true });
  } else {
    poll();
  }

  document.addEventListener('shopify:section:load', reveal);
})();
